import { CODE_LABELS } from "./options";

const KEY_LABELS = {
  completing_for: "Inquiry completed for", person_aware: "Person aware of inquiry", recipient_first_name: "Recipient first name",
  supports: "Support requested", supports_other: "Other support", hours_per_week: "Hours per week", start_timing: "Start timing",
  start_date: "Preferred start date", payment_method: "Anticipated financial coverage", payment_other: "Other coverage",
  single_occupancy_ack: "Acknowledged single-adult occupancy", support_details: "Supports needed",
  certification_details: "Main certification details", living_situation: "Current living situation", care_needs: "Care needed",
  palliative: "Palliative / end-of-life care", nursing_needs: "Ongoing nursing needs", nursing_details: "Nursing needs details",
  move_timeframe: "Move timeframe", coverage: "Anticipated financial coverage", coverage_other: "Other coverage",
  resident_first_name: "Senior's first name", gender_other: "Gender (specified)", funding_details: "Funding program / agency",
  rent_program_details: "Income support / subsidy program", living_other: "Living situation (other)",
  care_needs_other: "Other care needs", conditions: "General health conditions", conditions_other: "Other health condition",
  partner_category_other: "Partnership type (other)", property_type_other: "Property type (other)",
  memory: "Memory and cognitive support", mobility: "Mobility limitations", inquiry_type: "Inquiry type",
  move_in_timeframe: "Move-in timeframe", shared_spaces_ok: "Comfortable sharing living spaces",
  shared_bedroom_ok: "Comfortable sharing a bedroom", independence: "Able to live independently", rent_payment: "Anticipated rent payment",
  partner_category: "Partnership category", role_regulated: "Regulated role", no_cert_explanation: "Experience (no certification)",
  work_authorization: "Work authorization", employment_types: "Employment type", earliest_start: "Earliest start",
};

export const labelize = (key) => KEY_LABELS[key] || key.replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase());

export const formatValue = (v) => {
  if (Array.isArray(v)) return v.length ? v.join(", ") : "—";
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (v === null || v === undefined || v === "") return "—";
  return CODE_LABELS[v] || String(v);
};

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—";

export const summaryFor = (s) => {
  const a = s.answers || {};
  switch (s.category) {
    case "in_home_care": return (a.supports || []).slice(0, 2).join(", ");
    case "housing": return `${a.age_range || ""} · ${a.move_in_timeframe || ""}`;
    case "residential_support": return `${a.age_range || ""} · ${a.move_timeframe || a.move_in_timeframe || ""}`;
    case "caregiver_application": return a.preferred_role || "";
    case "property_owner":
    case "partnership": return `${a.organization || ""} · ${CODE_LABELS[a.partner_category] || ""}`;
    default: return a.topic || "";
  }
};
